import { ReactElement } from 'react';
import { useAuth } from 'react-oidc-context';
import { Button, Icon, Text } from '@intellecteu/common-ui';
import { clearClientSessionBeforeSignOut } from 'data';
import { Avatar, AvatarMenu, Dropdown } from 'ui';

import s from './styles.module.scss';

export const HeaderContainer = (): ReactElement => {
  const { isAuthenticated, user, signinRedirect, signoutRedirect, removeUser } = useAuth();
  const userName = user?.profile.preferred_username;

  const handleSignOut = () => {
    const run = async (): Promise<void> => {
      try {
        clearClientSessionBeforeSignOut();
        await signoutRedirect();
      } catch (err) {
        console.error('Sign out failed', err);
        try {
          await removeUser();
        } catch (e2) {
          console.error('removeUser after failed sign out failed', e2);
        }
      }
    };
    run().catch((err: unknown) => console.error('Sign out failed', err));
  };

  const menuOnClick = () => (!isAuthenticated ? signinRedirect() : handleSignOut());
  const menuLabel = !isAuthenticated ? 'Sign In' : 'Sign Out';

  return (
    <div className={s.header}>
      <div className={s.headerLeft} />
      <div className={s.headerRight}>
        <Dropdown triggerElement={<Avatar name={userName} />} shouldCloseOnClickInside={false}>
          <AvatarMenu name={userName}>
            <Button variant="tertiary" className={s.headerAvatarMenuIcon} onClick={menuOnClick} id="sign-out" size="xs">
              <Icon icon={Icon.icons.joinedPeer} size="s" />
              <Text size={Text.size.xs}>{menuLabel}</Text>
            </Button>
          </AvatarMenu>
        </Dropdown>
      </div>
    </div>
  );
};
